import React from 'react';
import LoadingDialog from 'components/LoadingDialog/LoadingDialog';
import AreasPanel from 'features/Areas/AreaPanel/AreaPanel';
import { useHostPerspectiveWaitingAreaState } from './HostPerspectiveWaitingArea.state';
import HostPerspectiveWaitingAreaView from './HostPerspectiveWaitingArea.view';
import IvicosStrings from 'kits/language/stringKit';
import NotificationsLayer from 'features/NotificationsLayer/NotificationsLayer';

const HostPerspectiveWaitingArea = (): any => {
    const state = useHostPerspectiveWaitingAreaState();

    return (
        <>
            {state.isLoadingDialogVisible && (
                <LoadingDialog loadingStrings={[IvicosStrings.loadingStringHostPerspectiveWaitingArea]} view="full" typewriter={false} />
            )}
            <AreasPanel />
            <NotificationsLayer />
            <HostPerspectiveWaitingAreaView
                {...{
                    ...state
                }}
            ></HostPerspectiveWaitingAreaView>
        </>
    );
};

export default HostPerspectiveWaitingArea;
